import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Dialog } from '@material-ui/core'
import PropTypes from 'prop-types'

const useStyles = makeStyles(theme => ({
  dialogPaper: {
    borderRadius: 10,
    [theme.breakpoints.down('sm')]: {
      padding: 0,
      paddingTop: 14,
      paddingBottom: 35
    },
    animation: '$slideUp 0.3s ease-out forwards'
  },
  scrollPaper: {
    [theme.breakpoints.down('sm')]: {
      alignItems: 'flex-end'
    }
  },
  '@keyframes slideUp': {
    from: {
      transform: 'translateY(100%)'
    },
    to: {
      transform: 'translateY(0)'
    }
  }
}))
const DialogAster = ({ open, onClose, ...props }) => {
  const classes = useStyles()
  return (
    <Dialog
      open={open}
      onClose={onClose}
      classes={{ paper: classes.dialogPaper, scrollPaper: classes.scrollPaper }}
      {...props}
    >
      {props.children}
    </Dialog>
  )
}
export default DialogAster
DialogAster.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  children: PropTypes.node
}
